import { ODRendererClickActionType } from '@odc/odbelt'
import React from 'react'
import { Link } from 'react-router-dom'
export var ODActionWrapper = function (_props) {
  var action = _props.action,
    value = _props.value,
    context = _props.context,
    children = _props.children
  if (!action) {
    return React.createElement(React.Fragment, null, children)
  }
  switch (action.actionType) {
    case ODRendererClickActionType.GoToEdit: {
      return React.createElement(
        Link,
        { to: context.parentContext.EditLinkFunc(value), style: { textDecoration: 'none' } },
        children
      )
    }
  }
}
//# sourceMappingURL=ODActionWrapper.js.map
